const SaberHangers = () => {
	return <h1>SaberHangers</h1>;
  };
  
  export default SaberHangers;